import { render } from "./TaskPriority.vue?vue&type=template&id=095fb350&scoped=true"
import script from "./TaskPriority.vue?vue&type=script&lang=js"
export * from "./TaskPriority.vue?vue&type=script&lang=js"

import "./TaskPriority.vue?vue&type=style&index=0&id=095fb350&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-095fb350"]])

export default __exports__